import axios from "axios";

const api = axios.create({ withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    const esLlamadaAutenticada = !url.includes("/api/session") && !url.includes("/api/auth");
    if (err.response?.status === 401 && esLlamadaAutenticada) {
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export default api;
